$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isAtViewportMidline(el) {
  if (!el || !el.getBoundingClientRect) return false;
  if (!$(el).is(':visible')) return false;

  const rect = el.getBoundingClientRect();
  const vw = window.innerWidth || document.documentElement.clientWidth;
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const midY = vh / 2;

  // horizontally on-screen AND the element spans the middle line
  return rect.left < vw && rect.right > 0 && rect.top < midY && rect.bottom > midY;
}

function runCounters($block) {
  $block.addClass('el-start-count');
  $block.find('.el-count-js').each(function () {
    const $c = $(this);
    const target = +($c.data('value') || 0);
    $c.prop('Counter', 0).stop(true).animate(
      { Counter: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function (now) { $c.text(Math.ceil(now)); }
      }
    );
  });
}

function checkCountersInView() {
  $('.el-element-counter').each(function () {
    const $block = $(this);
    if ($block.hasClass('el-start-count')) return;          // only once
    if (isAtViewportMidline(this)) runCounters($block); // trigger when truly visible
  });
}

$(window).on('scroll load', checkCountersInView);


$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});



  function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.el-ADV3-day').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
    });
});